import React, { useState } from "react";
import "./navbar.css";
import Miogra from "../../assets/miogra_logo2.png";
import contactimg from "../../assets/contact.png";
import { Link } from "react-scroll";
import menu from "../../assets/menu.png";

const Navbar = () => {
  const [showmenu, setshowmenu] = useState(false);
  return (
    <nav className="navbar">
      <img src={Miogra} alt="logo" className="logo" />
      <div className="desktopmenu">
        <Link
          activeClass="active"
          to="intro"
          spy={true}
          smooth={true}
          offset={-100}
          className="desktopmenuitem"
        >
          Home
        </Link>
        {/* <Link
          activeClass="active"
          to="about"
          smooth={true}
          spy={true}
          offset={-45}
          className="desktopmenuitem"
        >
          About
        </Link> */}
        <Link
          activeClass="active"
          to="skillssection"
          spy={true}
          smooth={true}
          offset={-60}
          className="desktopmenuitem"
        >
          Features
        </Link>

        <Link
          activeClass="active"
          to="download"
          spy={true}
          smooth={true}
          offset={-50}
          className="desktopmenuitem"
        >
          Download
        </Link>
        <Link
          activeClass="active"
          to="contact"
          spy={true}
          smooth={true}
          offset={-50}
          className="desktopmenuitem"
        >
          Contact Us
        </Link>
      </div>
      {/* <Link
        className="desktopmenubtn"
        to="contactpage"
        smooth={true}
        offset={-50}
      >
        <img src={contactimg} alt="" className="desktopmenubtnimg" /> Contact Us
      </Link> */}

      <img
        src={menu}
        alt="logo"
        className="mobmenu"
        onClick={() => setshowmenu(!showmenu)}
      />
      <div
        className="navmobmenu"
        style={{ display: showmenu ? "flex" : "none" }}
      >
        <Link
          activeClass="active"
          to="intro"
          smooth={true}
          spy={true}
          offset={-100}
          className="mobmenuitem"
          onClick={() => setshowmenu(false)}
        >
          Home
        </Link>
        {/* <Link
          activeClass="active"
          to="about"
          smooth={true}
          spy={true}
          offset={-40}
          className="mobmenuitem"
          onClick={() => setshowmenu(false)}
        >
          About
        </Link> */}

        <Link
          activeClass="active"
          to="skillssection"
          spy={true}
          smooth={true}
          offset={-50}
          className="mobmenuitem"
          onClick={() => setshowmenu(false)}
        >
          Features
        </Link>

        <Link
          activeClass="active"
          to="download"
          smooth={true}
          offset={-50}
          spy={true}
          className="mobmenuitem"
          onClick={() => setshowmenu(false)}
        >
          Download
        </Link>
        <Link
          activeClass="active"
          to="contact"
          smooth={true}
          offset={-50}
          spy={true}
          className="mobmenuitem"
          onClick={() => setshowmenu(false)}
        >
          Contact Us
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
